let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("fzHDF"), load("ao3hz")]).then(() => parcelRequire('2nrfl'));